import { Typography, Box } from '@vp/swan';
import { b as buildExports } from './_virtual-index.js';
import React from 'react';
import { useLocalization } from './src-hooks-useLocalizations.js';
import { useProductStore } from './src-store-productPriceDetails.store.js';

const SetupFee = ({
  setupFee,
  priceProperties
}) => {
  const { t } = useLocalization();
  const { tenant = "" } = useProductStore((state) => state.basePriceExtractionConfig) || {};
  const { isSetupFeeIncluded = false } = priceProperties;
  const setupFeeValue = priceProperties?.vatInc ? setupFee?.taxed : setupFee?.untaxed;
  const hasSetupFee = setupFeeValue !== 0;
  if (isSetupFeeIncluded) {
    return /* @__PURE__ */ React.createElement(Typography, null, /* @__PURE__ */ React.createElement(Box, null, t("price-platform.includes-setup-fee")));
  }
  return /* @__PURE__ */ React.createElement(Typography, null, /* @__PURE__ */ React.createElement(Box, null, hasSetupFee && priceProperties && setupFeeValue ? /* @__PURE__ */ React.createElement(Typography, { display: "inline-block" }, /* @__PURE__ */ React.createElement(
    buildExports.RawPrice,
    {
      placeHolderText: "...",
      pricingInfo: {
        listPrice: setupFeeValue,
        discountPrice: setupFeeValue,
        minimumFractionDigits: 2,
        culture: priceProperties.locale,
        currency: priceProperties.currency,
        vatInc: priceProperties.vatInc,
        hideVatMessage: true
      },
      tenant
    }
  ), " ", t("price-platform.setup-fee"), " ", /* @__PURE__ */ React.createElement(
    buildExports.VatMessage,
    {
      pricingInfo: {
        vatInc: priceProperties.vatInc,
        culture: priceProperties.locale
      },
      placeHolderText: "...",
      tenant
    }
  )) : t("price-platform.no-setup-fee")));
};

export { SetupFee };
//# sourceMappingURL=src-components-SetupFee.js.map
